// Locale ↔ URL-code mapping shared by the hreflang, noindex and redirect helpers.
// gb (English) is the unprefixed default; every other locale lives under /<code>/.
export const langCodes = {gb: 'en', ee: 'et', de: 'de', es: 'es'}

export function langCode(locale)
{
  return langCodes[locale] || 'en'
}

// URL prefix for a locale: '' for the default, '/et' style otherwise.
export function urlPrefix(locale)
{
  const code = langCode(locale)
  return code === 'en' ? '' : '/' + code
}
